/** 简体中文语言包 */

const zhCN = {

  // ================================================================
  // 通用
  // ================================================================
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    reset: '重置',
    close: '关闭',
    refresh: '刷新',
    loading: '加载中...',
    processing: '处理中...',
    enabled: '已启用',
    disabled: '已禁用',
    online: '在线',
    offline: '离线',
    unknown: '(未知)',
    none: '(无)',
    noDescription: '无描述',
  },

  // ================================================================
  // 侧边栏
  // ================================================================
  sidebar: {
    appName: 'MisMiss',
    appSubtitle: 'Console',
    groupMonitor: '监控',
    groupManage: '管理',
    groupSystem: '系统',
    dashboard: '仪表盘',
    accounts: '账户总览',
    botManagement: 'Bot 管理',
    livestream: '直播间',
    pluginCenter: '插件中心',
    pluginLibrary: '插件库',
    server: '服务器',
    logs: '日志',
    timer: '定时消息',
    update: '程序更新',
    settings: '设置',
    lightMode: '浅色模式',
    darkMode: '深色模式',
    collapse: '收起菜单',
  },

  // ================================================================
  // 仪表盘
  // ================================================================
  dashboard: {
    title: '仪表盘',
    subtitle: 'MisMiss 服务器运行状态概览',
    enableBot: '启用 Bot',
    disableBot: '停用 Bot',
    botStatus: 'Bot 状态',
    livestreamCount: '直播间',
    pluginCount: '插件',
    timerMessage: '定时消息',
    onlineCount: '{n} 在线',
    offlineCount: '{n} 离线',
    enabledCount: '{n} 启用',
    disabledCount: '{n} 禁用',
    activeRotatingMessages: '活跃轮转消息',
    livestreamStatus: '直播间状态',
    pluginStatus: '插件状态',
    noLivestreams: '暂无直播间',
    noPlugins: '暂无插件',
    botPermissions: 'Bot 权限汇总',
    loadingDashboard: '加载仪表盘...',
  },

  // ================================================================
  // Bot 管理
  // ================================================================
  bot: {
    title: 'Bot 管理',
    notConfigured: '尚未配置 Bot',
    notConfiguredHint: '请在下方输入 Cookie 创建',
    createOrUpdate: '创建 Bot',
    updateBot: '更新 Bot',
    refreshInfo: '刷新信息',
    verifyCookie: '验证 Cookie',
    viewCookie: '查看 Cookie',
    enable: '启用',
    disable: '停用',
    enableBot: '启用 Bot',
    disableBot: '停用 Bot',
    cookie: 'Cookie',
    cookiePlaceholder: '粘贴 Missevan Cookie...',
    cookieLength: '长度: {n} 字符',
    permissions: '权限设置',
    create: '创建 Bot',
    creating: '创建中...',
    createSuccess: 'Bot 创建成功',
    createFailed: '创建失败',
    refreshComplete: '刷新完成',
    refreshFailed: '刷新失败',
    verifySuccess: 'Cookie 有效',
    verifyFailed: '验证失败',
    cookieExpired: 'Cookie 已过期',
    botStopped: 'Bot 已停用',
    botStarted: 'Bot 已启用',
    operationFailed: '操作失败',
    noPermission: '无权限',
    disableWarning: '停用后 Bot 将停止所有消息发送和事件处理，确定要继续吗？',
    enableConfirm: '确定要启用 Bot 吗？',
    cookieInfo: 'Cookie 信息',
    copy: '复制',
    copied: '已复制',
    copiedToClipboard: '已复制到剪贴板',
    available: '可用',
    unavailable: '不可用',
    introduction: '简介',
    botCreated: 'Bot 创建成功',
    botEnabled: 'Bot 已启用',
    botDisabled: 'Bot 已停用',
    updateCookie: '更新 Cookie',
    confirmDisable: '停用 Bot',
    confirmEnable: '启用 Bot',
    confirmRefresh: '刷新 Bot 信息',
    confirmVerify: '验证 Cookie',
    refreshMsg: '将重新请求 API 获取最新 Bot 信息。',
    verifyMsg: '将验证当前 Cookie 是否仍然有效。',
  },

  // ================================================================
  // Bot 权限
  // ================================================================
  permissions: {
    SEND_LIVESTREAM_MESSAGE: '发送直播间消息',
    SEND_PRIVATE_MESSAGE: '发送私信',
    SEND_BACKPACK_GIFT: '赠送背包礼物',
    SEND_GIFT: '赠送直售礼物',
    EXPOSE_COOKIE: '查看完整 Cookie',
    botNotGranted: 'Bot 未授予此项权限，无法启用',
    permissionAllowed: '权限 {key} 已允许',
    permissionDenied: '权限 {key} 已禁止',
    updateFailed: '权限更新失败',
  },

  // ================================================================
  // 直播间
  // ================================================================
  livestream: {
    title: '直播间管理',
    add: '添加',
    addRoom: '添加直播间',
    addPlaceholder: '输入直播间 ID...',
    addSuccess: '直播间已添加',
    addFailed: '添加失败',
    invalidId: '请输入有效的直播间 ID',
    refresh: '刷新',
    refreshed: '列表已刷新',
    refreshFailed: '刷新失败',
    enable: '启用',
    disable: '停用',
    enabling: '启用中',
    disabling: '停用中',
    join: '进入',
    quit: '退出',
    remove: '移除',
    removeConfirmTitle: '移除直播间',
    removeConfirmMsg: '确定要移除 {name} 吗？此操作不可撤销。',
    removeSuccess: '已移除',
    enableSuccess: '直播间已启用并连接',
    disableSuccess: '直播间已停用并断开',
    joinSuccess: '已进入直播间',
    quitSuccess: '已退出直播间',
    enableFailed: '启用失败',
    disableFailed: '停用失败',
    joinFailed: '进入失败',
    quitFailed: '退出失败',
    notFound: '直播间 {id} 不存在',
    noRooms: '暂无直播间',
    noRoomsHint: '在上方输入直播间 ID 添加',
    sendMessage: '发送弹幕',
    targetRoom: '目标直播间',
    priority: '优先级',
    messageContent: '消息内容',
    messagePlaceholder: '输入要发送的弹幕...',
    send: '发送',
    sendSuccess: '消息已发送',
    sendFailed: '发送失败',
    roomName: '房间名',
    score: '热度',
    status: '状态',
    connection: '连接',
    actions: '操作',
    creatorOnline: '主播在线',
    creatorOffline: '主播离线',
    refreshLive: '刷新直播间',
    refreshLiveFailed: '刷新失败',
    refreshLiveSuccess: '已刷新',
    enterRoom: '进入直播间',
    exitRoom: '退出直播间',
    removeRoom: '移除直播间',
  },

  // ================================================================
  // 插件中心
  // ================================================================
  plugin: {
    title: '插件中心',
    filterAll: '全部',
    filterEnabled: '已启用',
    filterDisabled: '已禁用',
    filterFailed: '失败',
    scanPlugins: '扫描新插件',
    scanning: '扫描中...',
    install: '安装插件',
    installing: '安装中...',
    installSuccess: '{name} 安装成功',
    installFailed: '安装失败',
    noValidMetadata: '无法从 zip 中读取有效的 metadata.yaml',
    alreadyInstalled: "插件 '{name}' 已安装，不能重复安装",
    versionNotHigher: "插件 '{name}' v{old} 已安装，上传版本 v{new} 不高于现有版本",
    noPlugins: '暂无插件',
    noEnabledPlugins: '无已启用的插件',
    noDisabledPlugins: '无已禁用的插件',
    loadFailed: '加载失败',
    toggle: '点击禁用',
    toggleOn: '点击启用',
    details: '详情',
    docs: '文档',
    reload: '重载',
    reloading: '重载中',
    reloadSuccess: '{name} 已重载',
    reloadFailed: '重载失败',
    uninstall: '卸载',
    uninstallTitle: '卸载',
    uninstallConfirm: '确认卸载',
    uninstallSuccess: '{name} 已卸载',
    uninstallFailed: '卸载失败',
    uninstallWarning: '此操作不可撤销！',
    deleteConfig: '删除配置文件',
    deleteConfigDesc: '移除 data/config/ 下的配置 JSON 文件',
    deleteData: '删除持久化数据',
    deleteDataDesc: '移除 data/plugins/ 下的插件数据目录',
    retry: '重试',
    retrySuccess: '加载成功',
    retryFailed: '重试失败',
    viewLog: '查看日志',
    errorLog: '错误日志',
    update: '插件更新',
    updateConfirm: '确认更新',
    updateDesc: '将先停止当前插件（如果正在运行），然后覆盖安装新版本。',
    updateFound: '发现已安装插件 {name} 的新版本：',
    updateSuccess: '{name} v{version} 更新完成',
    updateFailed: '更新失败',
    updateChangelog: '更新公告',
    readme: 'README',
    readmeModalTitle: '{name} · README',
    noReadme: '无 README 文档',
    loadDocFailed: '加载文档失败',
    doc: '文档',
  },

  // ================================================================
  // 插件详情抽屉
  // ================================================================
  pluginDetail: {
    basicInfo: '基本信息',
    listeners: '监听器',
    permissions: '权限管理',
    config: '配置',
    description: '描述',
    shortDesc: '简介',
    name: '名称',
    version: '版本',
    author: '作者',
    pluginId: 'Plugin ID',
    repo: '仓库',
    noHandlers: '无事件处理器',
    noPermissions: '无权限配置',
    noConfig: '此插件无配置项（无 _conf_schema.json）',
    effectiveFlag: '生效权限 Flag',
    botPermissionsLabel: 'Bot 权限',
    missingInBot: 'Bot 缺失权限',
    botGranted: 'Bot 已授予此权限',
    botNotGranted: 'Bot 未授予此权限（无法启用）',
    loadFailed: '加载失败',
    loadDetailFailed: '加载插件详情失败',
    configSaved: '配置已保存',
    saving: '保存中...',
    saveConfig: '保存配置',
  },

  // ================================================================
  // 动态配置表单
  // ================================================================
  configForm: {
    saveConfig: '保存配置',
    saving: '保存中...',
    selectPlaceholder: '-- 选择 --',
    add: '添加',
    emptyList: '暂无项目',
    integerError: '请输入有效整数',
    numberError: '请输入有效数字',
    arrayPlaceholder: '值...',
    templatePlaceholder: '模板内容...',
  },

  // ================================================================
  // 服务器控制
  // ================================================================
  server: {
    title: '服务器设置',
    running: '运行中',
    stopped: '已停止',
    status: '服务器状态',
    botLabel: 'Bot',
    livestreamCount: '直播间',
    pluginCount: '插件',
    control: '服务器控制',
    reload: '重载服务器',
    reloadDesc: '关闭后重新启动，刷新所有插件和连接',
    reloadConfirm: '重载服务器',
    reloadConfirmMsg: '重载将关闭后重新启动，刷新所有插件和直播间连接。确定要继续吗？',
    reloadSuccess: '服务器已重载',
    reloadFailed: '重载失败',
    shutdown: '关闭服务器',
    shutdownDesc: '停用所有 Bot、断开所有直播间、卸载所有插件',
    shutdownConfirm: '关闭服务器',
    shutdownConfirmMsg: '关闭后所有 Bot、直播间连接和插件都将停止。API 也将不可用。确定要关闭吗？',
    shutdownSuccess: '服务器已关闭',
    shutdownFailed: '关闭失败',
    statusFailed: '获取状态失败',
    hint: '提示',
    hintText: '关闭服务器后，Web API 也将不可用（因为 API 依赖 MissevanServer 实例）。如需重新启动，请重启整个 Python 进程。',
  },

  // ================================================================
  // 设置页
  // ================================================================
  settings: {
    title: '设置',
    logOutput: '日志输出',
    debugOutput: 'DEBUG 输出',
    debugDescription: '启用后日志将包含 DEBUG 级别的详细信息',
    debugEnabled: 'DEBUG 输出已启用',
    debugDisabled: 'DEBUG 输出已关闭',
    setFailed: '设置失败',
    serverConfig: '服务器配置',
    saveConfig: '保存配置',
    configSaved: '配置已保存',
    configSaveFailed: '保存失败',
    logLevelApplied: '日志等级已设为 {level}',
    invalidLogLevel: '无效的日志等级: {level}',
  },

  // ================================================================
  // 日志页
  // ================================================================
  logs: {
    title: '服务器日志',
    connected: '实时',
    disconnected: '离线',
    connecting: '连接中...',
    connectedLabel: 'WebSocket 已连接，实时接收日志...',
    connectingLabel: '正在连接...',
    entries: '{n} 条',
    waiting: '等待日志输出...',
    paused: '[已暂停]',
    resume: '继续',
    pause: '暂停',
    clear: '清空',
    export: '导出',
    search: '搜索日志关键词...',
    refresh: '刷新',
    scrollToBottom: '滚动到底部',
  },

  // ================================================================
  // WebSocket 日志
  // ================================================================
  ws: {
    connected: '已连接至 MisMiss 日志流',
    heartbeat: 'heartbeat',
    pong: 'pong',
  },

  // ================================================================
  // 配置字段标签
  // ================================================================
  configFields: {
    data_dir: '数据目录',
    state_file: '状态文件',
    timer_interval: '定时消息间隔(秒)',
    pip_mirror: 'pip 镜像源',
    dir: '日志目录',
  },
};

export default zhCN;
export type ZhCN = typeof zhCN;
